var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactIntelli(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74.233,
    height: 74.876,
    viewBox: "0 0 74.233 74.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "brain-circuit_17257933",
    d: "M73.965,39.089l-.225-2.406H63.665v-3.4l5.66-6.29a7.945,7.945,0,1,0-3.009-6.217,7.815,7.815,0,0,0,.146,1.478l-8.1,8.994v5.435h-5.3V29.16l1.922-5.773c.239.02.484.04.729.04a7.976,7.976,0,1,0-5.567-2.287L47.758,28.3v8.384h-5.3V28.3L40.069,21.14A7.944,7.944,0,1,0,34.5,23.427a6.628,6.628,0,0,0,.729-.04l1.922,5.773v7.523h-5.3V31.248l-8.1-8.994a7.708,7.708,0,0,0,.146-1.478,7.979,7.979,0,1,0-3.009,6.217l5.66,6.29v3.4H15.811l.285,2.91A29.066,29.066,0,0,0,22.784,55.5a21.289,21.289,0,0,1,4.348,18.79l-1.7,6.82L30.571,82.4l1.7-6.82A26.589,26.589,0,0,0,26.84,52.093a23.749,23.749,0,0,1-5-10.108H69.027a23.757,23.757,0,0,0,.742,2.837l3.473,10.419H68.967V65.892l-13.256.239V81.753h5.3V71.341l8.046-.146a5.334,5.334,0,0,0,5.21-5.3V60.544H80.6l-5.806-17.4a18.221,18.221,0,0,1-.835-4.05Zm.312-20.964a2.651,2.651,0,1,1-2.651,2.651A2.65,2.65,0,0,1,74.276,18.125Zm-18.558-5.3a2.651,2.651,0,1,1-2.651,2.651A2.65,2.65,0,0,1,55.718,12.822ZM31.857,15.474a2.651,2.651,0,1,1,2.651,2.651A2.65,2.65,0,0,1,31.857,15.474ZM15.95,23.427A2.651,2.651,0,1,1,18.6,20.776,2.65,2.65,0,0,1,15.95,23.427Z",
    transform: "translate(-7.99 -7.52)",
    fill: "#7b7bff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIntelli);
export default __webpack_public_path__ + "static/media/contact-intelli.b9957b5f1fc4d72c40f40e6d5428081a.svg";
export { ForwardRef as ReactComponent };